import { MeiliSearchClient } from "@henrotaym/meilisearch-js";
import setup from "@spa/setup";

const createMeilisearchClient = () => new MeiliSearchClient(process.env.MIX_MEILISEARCH_HOST, setup.meilisearch.token);

export default createMeilisearchClient;